module.exports = __webpack_public_path__ + "img/pinjamanselfservice.6df1c3fd.svg";